<template>
  <div class="star-rating-input">
    <p class="title title--6">
      {{ label }}
      <span
        v-if="showAsOptional && !validations.required"
        class="gray regular smaller"
      >
        (Optional)
      </span>
    </p>

    <div class="star-rating-input__options-container">
      <div class="star-rating-input__options">
        <div
          v-for="(option, index) in options"
          :key="option"
          :class="['star-rating-input__option', { 'star-rating-input--selected': option <= modelValue }]"
        >
          <input
            :id="name + index"
            v-model="_value"
            :name="name"
            :value="option"
            class="star-rating-input__input"
            type="radio"
          >
          <label
            :for="name + index"
            class="star-rating-input__label"
          >
            <div class="star-rating-input__icon">
              <span class="star-rating-input__unselected-icon icon far fa-star" />
              <span class="star-rating-input__selected-icon icon fa-star" />
            </div>

            <span class="ada-text">{{ option }} stars</span>
          </label>
        </div>
      </div>
    </div>

    <input-error
      v-if="errorMessage"
      :error="'Must select a rating.'"
      class="half-spacing-top"
    />
  </div>
</template>



<script>
  import { useField } from 'vee-validate';
  import { computed, watch } from 'vue';

  export default {
    name: 'StarRatingInput',

    inject: {
      validatedForm: {
        from: 'validatedForm',
        default: () => ({})
      }
    },

    props: {
      label: {
        type: String,
        required: true
      },

      name: {
        type: String,
        required: true
      },

      showAsOptional: {
        type: Boolean,
        default: false
      },

      validations: {
        type: Object,
        default() {
          return {};
        }
      },

      modelValue: {
        type: Number,
        default: null
      }
    },

    setup(props) {
      const rules = computed(() => props.validations);

      const { errorMessage, handleChange } = useField(() => props.name, rules, {
        initialValue: props.modelValue,
        label: props.label
      });

      watch(() => props.modelValue, handleChange);

      return { errorMessage };
    },

    data() {
      return {
        options: [1, 2, 3, 4, 5]
      };
    },

    computed: {
      _value: {
        get() {
          return this.modelValue;
        },
        set(newValue) {
          this.$emit('update:modelValue', newValue);
        }
      }
    }
  };
</script>
